module.exports = __webpack_public_path__ + "img/change-square.939ffae7.svg";